/**
 * Labstep
 *
 * @module components/CustomIdentifierSet/Action/Create
 * @desc Create Action for Custom Identifier Set
 */

import { CustomIdentifierSetFormCreate } from 'labstep-web/components/CustomIdentifierSet/Form/Create';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { PremiumFeatureScreenGuard } from 'labstep-web/core/PremiumFeature/ScreenGuard';
import type { APIResponse } from 'labstep-web/models';
import type React from 'react';
import type { CustomIdentifierSetActionCreateProps } from './types';

export const CustomIdentifierSetActionCreate: React.FC<
  CustomIdentifierSetActionCreateProps
> = ({ groupId, parentClass, onSuccess }) => (
  <Modal
    header="Custom Identifier"
    viewComponent={
      <ActionComponent
        type="text"
        text="Enable Custom Identifier"
        elementProps={{
          placeholder: true,
        }}
      />
    }
    content={
      <PremiumFeatureScreenGuard
        premiumFeature="custom_identifier"
        unstyled
      >
        <CustomIdentifierSetFormCreate
          groupId={groupId}
          parentClass={parentClass}
          options={
            onSuccess && {
              onSuccess: ({
                response,
              }: {
                response: APIResponse;
              }) => {
                const id = response.result;

                // FIXME Dirty hack changing onSuccess shape from response.result to object
                onSuccess({
                  group_id: groupId,
                  custom_identifier_set_id: id,
                });
              },
            }
          }
        />
      </PremiumFeatureScreenGuard>
    }
  />
);
